// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Snyn","option":"styles_option__3hAw-","selected":"styles_selected__2-kv6"};